import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import NewsletterDialog from "../components/NewsletterDialog";
import { episodes } from "../mock";
import { Bell } from "lucide-react";

const placeholders = episodes.slice(0, 6);

const EpisodesPage = () => (
  <div className="bg-[#eceae5] min-h-screen">
    <SEO title="Episodes — Coming Soon" description="The 20 PROOF podcast is coming soon: honest conversations about money, work, love, and the messy art of growing up in your 20s." type="website" />
    <Navbar solid />
    <header className="pt-36 md:pt-44 pb-10 px-6 md:px-10 max-w-[1400px] mx-auto">
      <p className="font-sans-ui uppercase tracking-[0.2em] text-sm text-neutral-500">The Podcast</p>
      <h1 data-testid="episodes-coming-soon-title" className="font-display text-5xl md:text-7xl text-neutral-900 mt-3" style={{ fontWeight: 700 }}>
        Coming Soon
      </h1>
      <p className="font-display italic text-neutral-600 text-lg md:text-xl mt-4 max-w-2xl">
        Honest conversations about money, work, love, and the messy art of growing up. The first episodes are on their way.
      </p>
      <NewsletterDialog
        trigger={
          <button
            data-testid="episodes-notify-btn"
            className="mt-8 inline-flex items-center gap-2 bg-neutral-900 hover:bg-neutral-700 text-white font-sans-ui text-[15px] px-8 py-4 rounded-full transition-all duration-300 hover:scale-[1.03]"
          >
            <Bell size={16} />
            Get notified
          </button>
        }
      />
    </header>

    <div className="px-6 md:px-10 max-w-[1400px] mx-auto">
      <div data-testid="episodes-coming-soon-grid" className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12 pb-28 pt-6">
        {placeholders.map((ep, i) => (
          <div key={ep.id} aria-hidden="true">
            <div className="relative w-full aspect-video overflow-hidden rounded-md bg-neutral-800">
              <img src={ep.thumbnail} alt="" className="w-full h-full object-cover scale-125 blur-[28px] grayscale" />
              <div className="absolute inset-0 bg-neutral-700/55" />
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="font-sans-ui uppercase tracking-[0.3em] text-xs text-white border border-white/70 rounded-full px-4 py-2">
                  Coming Soon
                </span>
              </div>
            </div>
            <div className="mt-4">
              <p className="font-sans-ui text-xs uppercase tracking-widest text-neutral-500">Episode {i + 1}</p>
              <div className="h-6 w-3/4 bg-neutral-300/70 rounded mt-2" />
              <div className="h-4 w-1/3 bg-neutral-300/50 rounded mt-2" />
            </div>
          </div>
        ))}
      </div>
    </div>

    <Footer />
  </div>
);

export default EpisodesPage;
